import { semanticColors } from "@louise/theme/tokens";

export const pricingSurfaceColors = {
  cardBackground: semanticColors.action.quiet.background,
  cardBorder: semanticColors.border.glass,
} as const;
